export default __webpack_public_path__ + "ui/assets/img/time-icon-16-grey.svg";